export const getHostResources = (resource: PerformanceResourceTiming) => {
    const appHost = window.location.host;
    const { host: resourceHost } = new URL(resource.name);

    return resourceHost === appHost;
};
